

<template>
  <div class="card-deck card-deck--newsroom justify-content-start">
    <div v-for="(post, index) in posts" :key="post.id || index" data-aos="fade-up"
            data-aos-offset="300"
            data-aos-duration="600"
            :data-aos-delay="200 * (index + 1)" class="card card--sd-highlight">
      <div class="card__image">
        <img class="card__img" :src="post.image" :alt="post.title">
      </div>
      <div class="card__body">
        <div class="card__btn">
          <a class="btn btn--download" :href="post.file" target="_blank">
            <span class="btn__icon"><i class="icon-download"></i></span>
            <span class="btn__title">{{ translate('download') }}</span>
          </a>
          <a class="btn btn--download" :href="post.url" target="_blank">
            <span class="btn__icon"><i class="icon-view-online"></i></span>
            <span class="btn__title">{{ translate('view.online') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { useTranslationStore } from '@/stores/translations';

const translationStore = useTranslationStore();
const translate = translationStore.translate;

const props = defineProps({
  posts: {
    type: [Object, Array],
    required: true,
  },
});
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/app";
  .card {
        &.card--sd-highlight {
        background-color: $white;
        border-radius: 0 0 16px 16px;
        box-shadow: 0px 0px 10px rgba($black, 0.3);
        margin-bottom: 2rem;
        .card__image {
            position: relative;
        }
        .card__img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .card__body {
        padding: 0.5rem;
        }
        .card__btn {
            display: flex;
            justify-content: center;
            align-items: center;
            .btn {
                &:not(:first-child) {
                    &::before {
                        content: "";
                        position: relative;
                        width: 1px;
                        height: 23px;
                        background-color: $green-6;
                        margin: 0 1rem;
                        pointer-events: none;
                    }
                }
            }
             @include media-breakpoint-down(lg) {
              flex-direction: column;
               .btn {
                &:not(:first-child) {
                  margin-top: 0.25rem;
                    &::before {
                        display: none;
                    }
                }
              }
            }
            @include media-breakpoint-down(sm) {
              flex-direction: row;
               .btn {
                &:not(:first-child) {
                  margin-top: 0;
                    &::before {
                        display: block;
                    }
                }
              }
            }
        }
        
        }
    }
</style>